<script setup>
  import {
    nextTick,
    onMounted,
    ref
  } from 'vue'

  import { useI18n } from '@shared/i18n.js'

  const language = ref('')
  const location = ref('')
  const service = ref('')

  const { mt, ltm, t, tm } = useI18n()
  const languages = ltm('ja', 'activerecord.enums.agent_profile.languages')

  const prefecturesEn = ltm('en', 'activerecord.enums.agent_profile.prefectures')
  const optionsPrefecture = Object.entries(tm('activerecord.enums.agent_profile.prefectures')).map(([ value, text ]) => ({ text, value: prefecturesEn[value] }))

  onMounted(() => {
    if (window.app.page && window.app.page.search_agent_key) {
      const searchKey = window.app.page.search_agent_key
      language.value = searchKey.language || ''
      location.value = searchKey.location || ''
      service.value = searchKey.service || ''
    }
    nextTick(() => $(".agencies_select.sumo_select select").SumoSelect())
  })

  const submit = () => {
    const url = new URL(window.app.page.search_path.replace("/:location", location.value == "" ? "" : `/${location.value}`))
    url.search = ''
    if (service.value != '') url.searchParams.append('service', service.value)
    if (language.value != '') url.searchParams.append('language', language.value)

    window.location.href = url.toString()
  }
</script>

<template>
  <div class="agencies_select sumo_select">
    <div class="sort_item">
      <label class="select_type_a">
        <select v-model="location" class="search-price-to for-sale">
          <option value="">{{ mt('agent_profile', 'agent_location') }}</option>
          <option v-for="({ value, text }) in optionsPrefecture" :key="`location-${value}`" :value="value">{{ text }}</option>
        </select>
      </label>
    </div>
    <div class="sort_item">
      <label class="select_type_a">
        <select v-model="service" class="search-price-to for-sale">
          <option value="">{{ mt('agent_profile','services') }}</option>
          <option v-for="(text, value) in tm('activerecord.enums.agent_profile.services')" :key="`service-${value}`" :value="value">{{ text }}</option>
        </select>
      </label>
    </div>
    <div class="sort_item">
      <label class="select_type_a">
        <select v-model="language" class="search-price-to for-sale">
          <option value="">{{ mt('agent_profile', 'supported_languages') }}</option>
          <option v-for="(text, value) in languages" :key="`language-${value}`" :value="value">{{ text }}</option>
        </select>
      </label>
    </div>
    <div class="search">
      <button type="button" class="btn btn_search" @click="submit">
        {{ t('c.search') }}
      </button>
    </div>
  </div>
</template>
